<div class="row">
    <img class="col d-md-none ratio-4x3 pe-0 me-0" [src]="pathImg" alt="photo d'illustration de l'article">
</div>

<h1>{{ title }}</h1>

<div class="container-lg mb-5">
    <img class="d-none d-md-block float-end ms-3 mb-3 ratio-4x3" [src]="pathImg" alt="photo d'illustration de l'article">
    <div class="text-start text-muted">{{ date }}</div>
    <p [innerHtml]="content" class="content"></p>
</div>
